export default {
  tractContents: [],
  tractContentLoadingStatus: 'not loading'
}
